import React from 'react';
import { Trip } from '../../../../../services/trips/api/tripsApi';
import { formatTripDates, calculateDaysRemaining } from '../../../../../services/trips/utils/dateUtils';
import { formatBudget, formatDestinations, getTripImage } from '../../../../../services/trips/utils/tripUtils';
import { extractTripUuid } from '../../../../../services/trips/utils/idUtils';
import ProgressBar from './ProgressBar';
import DaysRemaining from './DaysRemaining';
import StatusBadge from '../../TripDetail/helpers/StatusBadge';
import './TripCard.css';

interface TripCardProps {
  trip: Trip;
  onViewDetails: (tripId: string | number) => void;
  variant?: 'default' | 'past';
  showActions?: boolean;
}

const TripCard: React.FC<TripCardProps> = ({ 
  trip, 
  onViewDetails,
  variant = 'default',
  showActions = true 
}) => {
  const tripImage = getTripImage(trip.images);
  const destinations = formatDestinations(trip.destinations);

  return (
    <div className={`trip-card ${variant} ${trip.status}`}>
      <div className="trip-image">
        <span className="trip-icon">{tripImage}</span>
        <StatusBadge status={trip.status} />
        {variant === 'past' && trip.rating && (
          <div className="rating-badge">
            {'⭐'.repeat(trip.rating)}
          </div>
        )}
      </div>
      <div className="trip-details">
        <h4>{trip.title}</h4>
        <p className="trip-destinations">{destinations}</p>
        <p className="trip-dates">{formatTripDates(trip.dates)}</p>
        
        {variant !== 'past' && (
          <>
            <ProgressBar progress={trip.progress || 0} />
            <DaysRemaining dates={trip.dates} className="trip-days-remaining" />
          </>
        )}

        {trip.budget && (
          <div className="trip-budget">
            Budget: {formatBudget(trip.budget)}
          </div>
        )}

        {trip.activities && trip.activities.length > 0 && (
          <div className="trip-activities">
            <strong>Activities:</strong>
            <ul>
              {trip.activities.map((activity: string, index: number) => (
                <li key={index}>{activity}</li>
              ))}
            </ul>
          </div>
        )}

        {variant === 'past' && trip.memories && (
          <div className="trip-memories">
            📸 {trip.memories} memories
          </div>
        )}

        {showActions && (
          <div className="trip-actions">
            <button 
              className="btn-primary"
              onClick={() => {
                const uuid = extractTripUuid(trip.id);
                console.log('🔍 TripCard: View Details clicked for trip:', { 
                  originalId: trip.id, 
                  extractedUuid: uuid, 
                  title: trip.title 
                });
                onViewDetails(uuid);
              }}
            >
              View Details
            </button>
            {variant === 'default' && trip.progress !== undefined && trip.progress > 0 && (
              <button className="btn-secondary">Add Memories</button>
            )}
            {variant === 'past' && (
              <button className="btn-secondary">Share Trip</button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default TripCard;

